/** 登录注册 */
<template>
  <div class="account">
    <div :class="['content', {'align-center':$isPc}, 'justify-between']">
      <el-image v-if="$isPc" class="account-img mr-20 flex-1" :src="require('@/assets/images/account-img1.png')"
        fit="contain">
      </el-image>
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
import { regSendCode, register, loginSendCode, login } from '@/api/account'
export default {
  name: 'Accunt',
}
</script>
<style lang="scss" scoped>
.account {
  width: 100%;
  height: 100%;
  background-color: #347eed;
}
.account-img {
  max-width: 60%;
}
</style>